import { render, staticRenderFns } from "./ethnicSec.vue?vue&type=template&id=00324c6c&scoped=true&"
import script from "./ethnicSec.vue?vue&type=script&lang=js&"
export * from "./ethnicSec.vue?vue&type=script&lang=js&"
import style0 from "./ethnicSec.vue?vue&type=style&index=0&id=00324c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00324c6c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
